/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo, useState } from 'react';
import { Traveler } from '@marageti/z4-sdk/lib/people';
import { SearchResult } from '@marageti/z4-sdk/lib/entity';
import {
  Autocomplete,
  TextField,
  Stack,
  Typography,
} from '@mui/material';
import {
  useApiClient,
  useFetchInfiniteES,
} from '@marageti/z4-lib';

type TravelerLookupInputProps = {
  value: Traveler | null | undefined;
  onChange: any;
  inputProps?: any;
  readOnly?: boolean;
};

const getSimpleSearch = (term: string) => {
  const normalizedTerm = term.trim();
  return {
    fullText: normalizedTerm,
    phrase: normalizedTerm.includes('@'),
    pagination: { limit: 30, page: 1 },
  };
};

const TravelerLookupInput = ({
  value,
  onChange,
  inputProps = undefined,
  readOnly = false,
}: TravelerLookupInputProps) => {
  const apiClient = useApiClient();
  const [inputValue, setInputValue] = useState('');

  // Exicute traveler search
  const travlerSearchRequest = getSimpleSearch(inputValue);
  const {
    data: travelerData,
    isLoading: isTravelerLoading,
  } = useFetchInfiniteES<Traveler>(apiClient.peopleClient.postTravelerSearch, travlerSearchRequest, { revalidateOnFocus: false });

  // Format travler options for the autocomplete
  const travelers: Traveler[] = useMemo(() => (
    travelerData?.flatMap((searchResult: SearchResult<Traveler>) => searchResult.hits) || []
  ), [travelerData]);

  return (
    <Autocomplete
      id="travelerLookUp"
      readOnly={readOnly}
      isOptionEqualToValue={(o:any, v:any) => o?.id === v?.id}
      getOptionLabel={(option:any) => (option.fullName || '')}
      loading={isTravelerLoading}
      onChange={onChange}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      options={travelers}
      filterOptions={(x) => x}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Traveler"
          name="traveler"
          {...inputProps}
        />
      )}
      renderOption={({ key, ...rest }, option) => (
        <Stack component="li" key={key} {...rest}>
          <Typography width="100%" variant="body1">{option.fullName}</Typography>
          <Typography width="100%" variant="caption">{option.email}</Typography>
        </Stack>
      )}
      fullWidth
      value={value ?? null}
    />
  );
};

export default TravelerLookupInput;
